// components/TermsAction.jsx
import React, { useState } from "react";
import { RiFileList2Line } from "react-icons/ri";
import TermsModal from "./TermsModal";

export default function TermsAction({ formTypeId }) {
  const [open, setOpen] = useState(false);

  return (
    <>
      <button
        type="button"
        onClick={() => setOpen(true)}
        className="px-3 py-2 border rounded hover:bg-gray-50 flex items-center gap-2"
        title="View Terms & Conditions"
      >
        <RiFileList2Line /> View T&C
      </button>

      <TermsModal open={open} onClose={() => setOpen(false)} formTypeId={formTypeId} />
    </>
  );
}
